module.exports = __webpack_public_path__ + "static/ceia-0031ec7d30e0c608e5a109d1804f1a40.png";